import styled from "styled-components"

import StatefulInputWithLinethrough from "Catalog/Edit/shared/components/StatefulInputWithLinethrough"
import StatefulField from "shared/components/StatefulField"

export const FieldName = styled(StatefulInputWithLinethrough)`
  input {
    width: 8rem;
    text-overflow: ellipsis;
  }
`

export const FieldPrice = styled(StatefulField.MoneyInput)`
  input {
    width: 4rem;
  }
`

export const FieldRef = styled(StatefulField.Input)`
  input {
    width: 10rem;
    text-overflow: ellipsis;
  }
`

export const FieldEnabled = styled(StatefulField.Checkbox)`
  display: flex;
  justify-content: center;
`
